webpackJsonp([249251717908376],{

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/NupurGarg.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/JyotsnaKrishnan.jpeg";
	var icon4 = "https://winpeforum.com/assets/elements/RichaBajpai.jpg";
	var icon8 = "https://winpeforum.com/assets/elements/Nruthya.png";
	
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/sheshines/19june2025/15.jpg";
	var I2 = "https://www.winpeforum.com/assets/sheshines/19june2025/19.jpg";
	var I3 = "https://www.winpeforum.com/assets/sheshines/19june2025/17.jpg";
	var I4 = "https://www.winpeforum.com/assets/sheshines/19june2025/20.jpg";
	var I5 = "https://www.winpeforum.com/assets/sheshines/19june2025/13.jpg";
	var I6 = "https://www.winpeforum.com/assets/sheshines/19june2025/1.jpg";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/15.jpg";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/19.jpg";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/17.jpg";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/20.jpg";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/13.jpg";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/1.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon2,
	      desc: "<div>\n     Jyotsna Krishnan is Managing Partner at Elevar Equity and CEO and Co-founder at EPIC World. \n <br/><br/>\nWith over two decades of expertise in business and finance, Jyotsna is reshaping the way enduring companies are built to serve Entrepreneurial Households. As Managing Partner at Elevar Equity, she has built a high-performing investment practice known for spotting early opportunities, and partnering closely with entrepreneurs building transformational business models in critical sectors like agri, finance, and health. Jyotsna balances sharp commercial acumen with deep empathy, enabling her to identify and scale unique business models that drive real impact. She also leads the EPIC World team with its vision to help build and scale 50+ blue chip companies serving Entrepreneurial Households. She spends significant time in the field, gathering insights about Entrepreneurial Households\u2014an invaluable resource for companies serving this fast rising segment.\n\n\t\t</div>",
	      name: "Jyotsna Krishnan",
	      post: "<div>Managing Partner<br/> Elevar Equity, <br/>\nCEO and Co-founder<br/> EPIC World\n\n        </div>"
	    }, {
	      imgUrl: icon8,
	      desc: "<div>\n            Nruthya Madappa is Partner at 3one4 Capital. In addition to supporting investments, topline and capital growth for the portfolio at the firm, Nruthya works closely with global institutional and strategic investors to drive the growth of our portfolio companies. Her team partners deeply with the latter in planning and achieving financial and strategic objectives including capital raises, revenue acceleration, M&A, and exits.\n            <br/><br/>\n    Over her career in the US and India, Nruthya has led global teams across technology, finance, real estate, education and economic policy. Before 3one4 Capital, Nruthya founded and led The CoWrks Foundry (a business accelerator for early stage companies) as Managing Partner, investing in over 25 companies and establishing global partnerships with Yale and Columbia University.\n    <br/><br/>\n    Prior to The CoWrks Foundry she drove the Revenue and Growth orgs at Cuemath and spearheaded the 15M Series B from Capital G and Sequoia Capital for the edtech giant. Throughout her career, Nruthya has designed and scaled products, and raised capital for high growth companies - strengths she brings to bear for the 3one4 portfolio.\n    <br/><br/>\n    Nruthya holds BS and MS degrees in Electrical Engineering from Stanford University and an MBA from Harvard Business School.\n    \n            </div>",
	      name: "Nruthya Madappa",
	      post: "<div>Partner<br/>\n            3one4 Capital\n     \n            </div>"
	    }, {
	      imgUrl: icon1,
	      desc: "<div>\n          Nupur Garg is a leading investor in private equity and venture capital, and the founder of Winpe, an initiative to promote gender diversity in investing. She chairs the board of Kids Clinic India (Cloudnine Hospitals) and serves as an independent director at Edelweiss Real Assets, Kerala Infrastructure Fund Management, and Molbio Diagnostics. She is an advisor to the Dutch Good Growth Fund and has served on the boards and investment committees of SIDBI, NIIF, and the Fund of Funds for Startups.<br/><br/>\n\nRecognized globally, Nupur has been featured in PEI\u2019s Most Influential Women (2024) and the Forbes W-Power List (2020). She advises fund managers on governance and mentors women entrepreneurs.\n<br/><br/>\nA Chartered Accountant and MIT Sloan MBA, with executive education from Harvard, Nupur earlier led IFC\u2019s South Asia PE/VC practice, delivering its first positive returns.\n\n            </div>",
	      name: "Nupur Garg",
	      post: "<div>Founder<br/>Winpe\n    \n    \n            </div>"
	    }, {
	      imgUrl: icon4,
	      desc: "<div>\n          Richa is the Founder & CEO of Campus Fund - Asia's largest VC Fund investing in student-led startups in India. She was also part of the Investment Committee of Creator Fund investing in Student Led Startups in the UK,European Region.\n<br/><br/>\nRicha co-founded Goodera - A global technology company that helps large enterprises, measure and manage the impact of their CSR, Sustainability & Volunteering initiatives. Goodera manages more than $300m of development capital on behalf of its clients. Goodera valued at $150Mn+, since inception in 2014 has raised capital from the likes of Omidyar Network, Teneo Ventures, Elevation Capital, xto10x, Zoom Ventures, Ursula Burns amongst others.\n<br/><br/>\nShe also spent time as an advisor at a boutique PE firm headquartered in London, called Blue Knot Partners backed by Relay Investments.\n<br/><br/>\nRicha has done her MBA from London Business School and has also been recognized as part of the Forbes 30u30 India (2014) & Asia (2016) list, MIT Innovators under 35 India (2016) List and Young Global Leader (2024) by World Economic Forum.\n\n            </div>",
	      name: "Richa Bajpai",
	      post: "<div>Founder<br/>Campus Fund\xA0and\xA0Goodera\n    \n    \n            </div>"
	    }];
	
	    _this.Speaker2 = [{
	      imgUrl: icon2,
	      desc: "Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.\n<br/><br/>\nAt McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.\n\n\n         ",
	      name: "Alka Goel",
	      post: "<div>Founding Partner<br/> Alkemi Growth Capital\n        </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I2, ImgSrc1: II2 }, { id: 22, ImgSrc: I3, ImgSrc1: II3 }, { id: 19, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 34, ImgSrc: I6, ImgSrc1: II6 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "sheshines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "sheshines with Winpe "
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "June 19, 2025 (5:00 - 8:00 PM IST)"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Bangalore "
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Hosted By:"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("img", { src: "https://winpeforum.com/assets/elements/epicworld-removebg-preview.png", style: { width: '100px' } }),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            ),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "Yet another engaging edition of sheshines in Bangalore on June 19, 2025, brought together founders and investors. Co-hosted by Epic World, the topic for the evening was titled ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "\"The Founder\u2013Investor Dance: Building High-Trust Relationships with the Right Capital Partner\u201D"
	              ),
	              " and was held at the Epic World office.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The event kicked off with a lively round of Human Bingo- a fun, interactive icebreaker that sparked spontaneous conversations and shared laughter. ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Event Highlights"
	              ),
	              "          ",
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              "The conversation for the evening brought together some of the most respected voices in the entrepreneur and investment landscape to discuss what makes founder-investor relationships truly work- beyond the pitch and the term sheet.",
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                    "Speakers"
	                  ),
	                  "          ",
	                  _react2.default.createElement("div", { "class": "r_btm" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Our_Speakers container" },
	                    _react2.default.createElement(
	                      "center",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Speakers_img", style: { width: '100%', margin: '0' } },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          this.Speaker1.map(function (item, i) {
	                            if (i <= 3) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                  key: i
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "Scardd" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "s_img",
	                                      onClick: function onClick() {
	                                        return _this3.togglePopUp(item);
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "center",
	                                      null,
	                                      "  ",
	                                      _react2.default.createElement("img", {
	                                        src: item.imgUrl,
	                                        alt: item.name,
	                                        className: "img-responsive",
	                                        style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement("br", null),
	                                  "    ",
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_name",
	                                    dangerouslySetInnerHTML: { __html: item.name }
	                                  }),
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_post",
	                                    dangerouslySetInnerHTML: { __html: item.post }
	                                  })
	                                )
	                              );
	                            } else return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("br", null),
	              "Moderated with nuance and depth by Nupur Garg, Founder of Winpe, the panel explored how trust is built and sustained, the importance of value alignment, and how founders can choose capital partners who support long-term vision over short-term returns.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Key Takeaways from the evening:"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Trust, Transparency & Respect are Foundational"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "A healthy founder-investor relationship is built on complete transparency, mutual trust, and respect. Investors must give founders the space to operate and trust their on-the-ground decision-making. Recognizing that great businesses are built by people of diverse personalities, ages, and genders is essential."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Set Expectations Early"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Misalignment often begins when roles and expectations are unclear. It\u2019s critical to set boundaries and align on vision from the outset. Unequal treatment of co-founders and lack of faith in the founder\u2019s vision are common sources of friction."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Invest in the Relationship \u2013 Not Just the Company"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Strong one-on-one relationships between founders and investors help weather difficult times. Founders should feel empowered to ask questions, and investors should routinely check in with all co-founders. This two-way relationship requires emotional intelligence and egos left at the door."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Transparent and Regular Reporting is a Must"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "When things are going well, reporting often gets overlooked. But consistent, transparent updates from both sides create alignment and reduce the risk of conflict during tougher times."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Founders Should Also Screen Investors"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Just as investors conduct diligence, founders should assess investor alignment\u2014values, expectations, and engagement style matter. Building with the right partner is key to long-term success."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Education & Age Are No Longer Barriers"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "The forum acknowledged that we are at an inflection point in how we value education and experience. Degrees and age are no longer accurate predictors of a founder\u2019s ability. Authenticity, clarity of vision, and execution are far more important."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Play to Strengths, Not Control"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Investors should support founders in areas where they can add true value rather than overstepping. The best partnerships come from complementing, not controlling."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Leadership That Attracts Talent"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "A key skill of successful founders is the ability to build strong teams\u2014by being authentic, honest, and by hiring people smarter than themselves. A founder\u2019s brand and values are crucial in attracting and retaining talent."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Shared Goal: Company\u2019s Success"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Ultimately, both founders and investors are aligned in one critical objective\u2014the success of the company. When this shared purpose is prioritized, stronger and more resilient partnerships are built."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              "The session concluded with an interactive Q&A giving attendees the freedom to ask candid questions and learn from the speakers\u2019 journeys in a closed, trusted setting.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "In the lead-up to Winpe\u2019s annual Leadership Summit & Awards 2026, we gifted exclusive WLSA giveaways to the winner of the Human Bingo - Shobha Venkataraman, Partner at Elevar Equity.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The event was part of Winpe sheshines, a series of knowledge and networking events. Winpe sheshines is committed to fostering meaningful connections and bridging opportunities between women entrepreneurs and investors in the PEVC ecosystem."
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Heading2.default, { title: "Gallery" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.CollegiumsImages.map(function (item, j) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-4 col-sm-6 col-xs-12", style: { padding: '8px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img_card" },
	                      _react2.default.createElement("img", { style: { width: '100%' }, src: item.ImgSrc, alt: "Winpe sheshines" }),
	                      _react2.default.createElement(
	                        "a",
	                        { href: item.ImgSrc1 },
	                        " ",
	                        _react2.default.createElement("i", { style: { color: 'white', position: 'absolute', left: '20px', top: '20px' }, "class": "fa fa-2x  fa-download " })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "gallery/" },
	                _react2.default.createElement(
	                  "button",
	                  { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                  "View All Images"
	                ),
	                " "
	              ),
	              " "
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sheshines-19-june-2025-index-js-211291db9303d4bb9c22.js